import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { t } from 'i18next';
import {
  RowLabel,
  UploadButton,
  UploadDocumentsContainer,
  UploadDocumentsRow,
  UploadDocumentsRowContainer,
  CheckmarkIcon,
  FileNameContainer,
  FileUploadLabel,
  FileInputField,
  ButtonsCol,
  UploadButtonLabel,
} from './css';
import UploadDocumentsRenderModes from './constants';

const ATTACHED_DOCUMENTS_STORE_KEY = 'attachedDocuments';

// eslint-disable-next-line no-unused-vars
const UploadDocumentsReviewRow = ({ rowLabel = '', ...rest }) => {
  const { input } = rest;

  return (
    <FileNameContainer>
      {input.value.name && (
        <>
          <FileUploadLabel>{input.value.name}</FileUploadLabel>
          <CheckmarkIcon />
        </>
      )}
    </FileNameContainer>
  );
};

UploadDocumentsReviewRow.propTypes = {
  rowLabel: PropTypes.string,
  input: PropTypes.object,
};

const UploadDocuments = ({
  numberOfPlaceholders = 0,
  documentFields,
  storeKey = ATTACHED_DOCUMENTS_STORE_KEY,
  renderMode = UploadDocumentsRenderModes.INPUT,
  attachedDocuments,
  onFileError,
}) => {
  const renderOptions = (documentFields, attachedDocuments) => (
    <UploadDocumentsRowContainer>
      {

        documentFields.map(((documentType) => {
          const docId = documentType.id;
          const attached = attachedDocuments?.[docId] || {};
          const attachmentCount = Object.keys(attached).length;
          const frmAttachName = `${storeKey || ATTACHED_DOCUMENTS_STORE_KEY}.${docId}`;
          const rndNumber = Date.now();
          return (
            <UploadDocumentsRow key={documentType.id}>
              <RowLabel field={t(documentType.id)} />
              <ButtonsCol>
                {
                attachmentCount > 0
                  ? (
                    <>
                      <UploadButton
                        component={FileInputField}
                        attachButton={
                          <UploadButtonLabel>{t('Upload')}</UploadButtonLabel>
                        }
                        name={`${frmAttachName}.${docId}_${rndNumber}`}
                        onFileError={onFileError}
                      />
                      {
                      Object.keys(attachedDocuments[documentType.id]).map((key) => (
                        <UploadButton
                          component={FileInputField}
                          attachButton={`${storeKey || ATTACHED_DOCUMENTS_STORE_KEY}.${documentType.id}.${key}`}
                          name={`${storeKey || ATTACHED_DOCUMENTS_STORE_KEY}.${documentType.id}.${key}`}
                          key={`${documentType.id}.${key}`}
                          onFileError={onFileError}
                        />
                      ))
                    }
                    </>
                  )
                  : (
                    <UploadButton
                      component={FileInputField}
                      attachButton={
                        <UploadButtonLabel>{t('Upload')}</UploadButtonLabel>
                      }
                      name={`${storeKey || ATTACHED_DOCUMENTS_STORE_KEY}.${documentType.id}.${documentType.id}_0`}
                      onFileError={onFileError}
                    />
                  )
                }
              </ButtonsCol>
            </UploadDocumentsRow>
          );
        }))
      }
    </UploadDocumentsRowContainer>
  );

  const renderPlaceholders = (numberOfPlaceholders, attachedDocuments) => {
    const placeholderElements = [];
    let rowLabel = '';
    let fieldName = '';
    const totalDocuments = attachedDocuments ? Object.keys(attachedDocuments.documentsUpload).length : 1;
    const maxNumberOfPlaceholders = totalDocuments > numberOfPlaceholders ? numberOfPlaceholders : totalDocuments;

    for (let i = 0; i < maxNumberOfPlaceholders; i++) {
      const fileName = attachedDocuments ? Object.keys(attachedDocuments.documentsUpload) : 0;
      rowLabel = `${t('Document')} ${i}`;
      fieldName = `${storeKey || ATTACHED_DOCUMENTS_STORE_KEY}.documentsUpload.${fileName ? fileName[i] : 'documentsUpload_0'}`;

      placeholderElements.push(
        <React.Fragment key={rowLabel}>
          {renderMode === UploadDocumentsRenderModes.INPUT && (
            <UploadDocumentsRow>
              <RowLabel field={rowLabel} />
              <UploadButton
                component={FileInputField}
                attachButton={t('AttachDocument')}
                name={fieldName}
              />
            </UploadDocumentsRow>
          )}

          {renderMode === UploadDocumentsRenderModes.REVIEW && (
            <Field
              name={fieldName}
              component={UploadDocumentsReviewRow}
              rowLabel={rowLabel}
            />
          )}

        </React.Fragment>,
      );
    }

    return <UploadDocumentsRowContainer>{placeholderElements}</UploadDocumentsRowContainer>;
  };

  return (
    <UploadDocumentsContainer>
      {documentFields && renderOptions(documentFields, attachedDocuments)}
      {numberOfPlaceholders > 0 && renderPlaceholders(numberOfPlaceholders, attachedDocuments)}
    </UploadDocumentsContainer>
  );
};

UploadDocuments.propTypes = {
  numberOfPlaceholders: PropTypes.number,
  documentFields: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })),
  storeKey: PropTypes.string,
  renderMode: PropTypes.oneOf([
    UploadDocumentsRenderModes.INPUT,
    UploadDocumentsRenderModes.REVIEW,
  ]),
  attachedDocuments: PropTypes.object,
  onFileError: PropTypes.func,
};

export default UploadDocuments;
